// App Configuration
export const DISCLAIMER = 'El contenido de este chat ha sido generado por un sistema de IA y puede contener errores, inconsistencias o información desactualizada.';
export const NOT_AUTH_USER = 'Tu usuario no tiene los permisos necesarios para utilizar esta aplicación. Por favor, ponte en contacto con el administrador para resolver este problema.';
export const VERSION = "GenovAi Demo v1.0.0  - Orq 0.1.0.1 - Modelo gpt-4o";
export const SIZE_CONVERSATION = 100;
export const AUTH_GROUP = 'GenovAi_Authorized_Users';

export const ORCHESTATION_URL = process.env.REACT_APP_ORCHESTATION_URL;

export const USER_GROUPS = {
  'GenovAi_Context_Training': 
  {
    'index': 'formacion',
    'semantic_configuration': 'formacion-semantic-configuration'
  },
  'GenovAi_Context_Sales_aftersales_and_marketing': 
  {
    'index': 'sales-aftersales-mkt',
    'semantic_configuration': 'sales-aftersales-mkt-semantic-configuration'
  },
	'GenovAi_Context_Research_and_development': 
  {
    'index': 'research-development',
    'semantic_configuration': 'research-development-semantic-configuration'
  },
	'GenovAi_Context_Purchasing': 
  {
    'index': 'purchasing',
    'semantic_configuration': 'purchasing-semantic-configuration'
  },
	'GenovAi_Context_Production_and_logistics': 
  {
    'index': 'production-logistics',
    'semantic_configuration': 'production-logistics-semantic-configuration'
  },
	'GenovAi_Context_People_and_organization': {
    'index': 'people-organization',
    'semantic_configuration': 'people-organization-semantic-configuration'
  },
	'GenovAi_Context_IT': {
    'index': 'technology',
    'semantic_configuration': 'technology-semantic-configuration'
  },
	'GenovAi_Context_Finance': {
    'index': 'finance',
    'semantic_configuration': 'finance-semantic-configuration'
  },
	'GenovAi_Context_Central_Services': {
    'index': 'central-functions',
    'semantic_configuration': 'central-functions-semantic-configuration'
  },
  'GenovAi_Context_Quality': {
    'index': 'quality',
    'semantic_configuration': 'quality-semantic-configuration'
  },
  'GenovAi_Context_SGP': {
    'index': 'sgp',
    'semantic_configuration': 'sgp-semantic-configuration'
  },  
  'GenovAi_Context_I+D-infotainment': {
    'index': 'infotainment',
    'semantic_configuration': 'infotainment-semantic-configuration'
  },  
};


export const API_DATA_SOURCES = {
  "type": "azure_search",
  "parameters": {
    "index_name": "finance",
    "embedding_dependency": {
        "type": "deployment_name",
        "deployment_name": "text-embedding-ada-002"
    },
    "fields_mapping": {},
    "in_scope": false,
    "semantic_configuration": "vector_semantic_hybrid",
    "strictness": 5,
    "top_n_documents": 4,
    "ephemeralId": null,
    "new_document": false,
    "conversationId": null,
    "vector_store_id": null,
    "thread_id": null
  }
};

export const CHAT_ROLE = {
    "type": "template",
    "content": "0"
} // iRole

export const LLM_MODEL = 'gpt-4o';

export const API_PARAMETERS = {
  "temperature": 0.1,
  "top_p": 1,
  "max_tokens": 1500,
  "stop": null,
  "stream": true
}

export const REQUEST_OPTIONS = {
  approach: 'rrr',
  overrides: {
    retrieval_mode: 'hybrid',
    semantic_ranker: true,
    semantic_captions: false,
    suggest_followup_questions: true,
  },
};


export const GenovAi_ID = '7d06c06a-074f-438a-9916-884698ab705a';

